import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@material-ui/core";
import { Module } from "../hooks";

type Props = {
  open: boolean;
  onClose: () => void;
  module: Module;
};

export const NotificationDialog: React.VFC<Props> = (props) => {
  const classes = useStyles();
  const {
    states: { dialogData },
    setters: { changeValue },
    actions: { registorNotification },
  } = props.module;

  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="md" fullWidth>
      {dialogData.docID === undefined && (
        <DialogTitle>以下の内容を全アプリユーザーに通知します</DialogTitle>
      )}
      <DialogContent className={classes.dialogContent}>
        <TextField
          className={classes.dialogTextField}
          label="通知タイトル"
          value={dialogData.title}
          onChange={(e) => changeValue(e, "title")}
          variant="outlined"
        />
        <TextField
          className={classes.dialogTextField}
          label="通知内容"
          value={dialogData.message}
          onChange={(e) => changeValue(e, "message")}
          multiline
          rows={15}
          variant="outlined"
        />
      </DialogContent>
      {dialogData.docID === undefined && (
        <DialogActions>
          <Button onClick={props.onClose} variant="contained">
            キャンセル
          </Button>
          <Button
            onClick={registorNotification}
            disabled={dialogData.title === "" || dialogData.message === ""}
            color="secondary"
            variant="contained"
          >
            通知する
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

const useStyles = makeStyles({
  dialogContent: {
    paddingBottom: 20,
  },
  dialogTextField: {
    width: "100%",
    marginTop: 10,
    marginBottom: 10,
  },
});
